import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Flex, Divider, Hide, Card, getPaletteColor } from 'pcln-design-system'

import { WidthSkeleton } from '../WidthSkeleton'
import Repeat from '../../Repeat/Repeat'

const CardWrap = styled(Card)`
  max-width: 810px;
  width: 100%;
`

const SliceFlex = styled(Flex)`
  height: 82px;
  max-width: 592px;

  &:not(:first-of-type) {
    border-top: 1px solid ${getPaletteColor('border.base')};
  }
`

function Slice() {
  return (
    <SliceFlex alignItems={'center'}>
      <WidthSkeleton width={'20px'} height={'20px'} mr={'24px'} />
      <WidthSkeleton width={'48px'} height={'20px'} mr={'16px'} />
      <Hide xs sm>
        <WidthSkeleton width={'48px'} height={'48px'} mr={'24px'} />
      </Hide>
      <WidthSkeleton width={'48px'} height={'20px'} mr={'8px'} />
      <Divider borderColor={'border.base'} width={'120px'} mr={2} />
      <WidthSkeleton width={'48px'} height={'20px'} mr={'104px'} />
      <WidthSkeleton width={'32px'} height={'20px'} />
    </SliceFlex>
  )
}

export function ItinerarySkeleton({ slices }) {
  return (
    <CardWrap borderRadius='xl'>
      <Flex flexDirection={'column'} px={3} pb={3}>
        <Repeat times={slices}>
          <Slice />
        </Repeat>
        <WidthSkeleton width={'260px'} height={'12px'} mb={'8px'} />
        <WidthSkeleton width={'160px'} height={'12px'} />
      </Flex>
    </CardWrap>
  )
}

ItinerarySkeleton.defaultProps = {
  slices: 2,
}

ItinerarySkeleton.propTypes = {
  slices: PropTypes.number,
}
